export default __webpack_public_path__ + "static/akitabox_report_footer.75421b982790873db7310e68b7964eb9.png";